module.exports = __webpack_public_path__ + "img/Knok_halo.10bb31cf.png";